import { render, staticRenderFns } from "./CommonWriteMsResult.vue?vue&type=template&id=273fcaae&scoped=true"
import script from "./CommonWriteMsResult.vue?vue&type=script&lang=js"
export * from "./CommonWriteMsResult.vue?vue&type=script&lang=js"
import style0 from "./CommonWriteMsResult.vue?vue&type=style&index=0&id=273fcaae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273fcaae",
  null
  
)

export default component.exports